import { useField, splitFormProps } from 'react-form';
const useManagedField = (props) => {
    const { validations, name, ...rest } = props;
    async function validate(value, instance) {
        // need a debounce here to prevent validations from getting triggered too many times by fast typers
        return instance.debounce(() => {
            for (const validator of validations) {
                if (!validator.isValid(value)) {
                    return validator.message;
                }
            }
            return false;
        }, 500);
    }
    const inputProps = { validate, ...rest };
    const [field, fieldOptions, newRest] = splitFormProps({ field: name, ...inputProps });
    const { meta, getInputProps, setValue, } = useField(field, fieldOptions);
    return {
        meta,
        inputProps: getInputProps(newRest),
        setValue,
    };
};
export default useManagedField;
//# sourceMappingURL=useManagedField.js.map